var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBlankCircle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.5 7C0.5 3.42614 3.42614 0.5 7 0.5C10.5739 0.5 13.5 3.42614 13.5 7C13.5 10.5739 10.5739 13.5 7 13.5C3.42614 13.5 0.5 10.5739 0.5 7Z",
    fill: "#EBF5FF",
    stroke: "#2093C1"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBlankCircle);
export default __webpack_public_path__ + "static/media/blank-circle.da7efadaf7bcabf777319bae776adff5.svg";
export { ForwardRef as ReactComponent };